import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static values = { bulkUpdateUrl: String };
  static targets = ['bundleRow'];

  connect() {
    this.bundleBeingDragged = null;
    this.dragOverElement = null;
  }

  bundleRowTargetConnected(row) {
    row.addEventListener('dragstart', (event) => {
      if (event.target.classList.contains('strategy')) {
        return;
      }

      event.dataTransfer.effectAllowed = 'move';
      this.bundleBeingDragged = event.currentTarget;
    });
    row.addEventListener('dragover', (event) => {
      if (this.bundleBeingDragged == null) {
        return;
      }

      this.endDragEffect();
      this.dragOverElement = event.currentTarget;
      this.dragOverElement.classList.add('dragging-over');
      event.preventDefault();
    });
    row.addEventListener('dragend', (event) => {
      this.endDragEffect();
      event.preventDefault();
    });
    row.addEventListener('drop', (event) => {
      if (this.bundleBeingDragged == null) {
        return;
      }

      this.endDragEffect();
      this.reorderAssigned();
      this.bundleBeingDragged = null;
    });
  }

  endDragEffect() {
    if (this.dragOverElement != null) {
      this.dragOverElement.classList.remove('dragging-over');
    }
  }

  reorderAssigned() {
    let bundleIds = this.bundleRowTargets.map(
      (bundle) => bundle.dataset.bundleId
    );
    this.removeDraggedElement(bundleIds);
    this.insertDraggedElement(bundleIds, this.dragOverElement.dataset.bundleId);
    let formData = new FormData();
    bundleIds.forEach((bundleId) => {
      formData.append('strategy_bundle_ids[]', bundleId);
    });
    this.sendRequest('patch', this.bulkUpdateUrlValue, formData);
  }

  removeDraggedElement(list) {
    const element = this.bundleBeingDragged.dataset.bundleId;
    const start = list.indexOf(element);
    const deleteCount = 1;
    list.splice(start, deleteCount);
  }

  insertDraggedElement(list, referenceElement) {
    const element = this.bundleBeingDragged.dataset.bundleId;
    const start = list.indexOf(referenceElement);
    const deleteCount = 0;
    /*if (this.isPlaceholderPhoneShownAbove) {
      list.splice(start, deleteCount, element);
    } else {*/
    list.splice(start + 1, deleteCount, element);
    //}
  }

  sendRequest(type, url, data) {
    Rails.ajax({
      url: url,
      type: type,
      dataType: 'json',
      data: data,
      success: (event, _status, _xhr) => {
        this.element.innerHTML = event.htmlContent;
      }
    });
  }
}
